import { Options } from "../../../types";

export const queryKeys = {
  getEmployeePledgeLookups: "getEmployeePledgeLookups",
  getEmployeePledge: "getEmployeePledge",
  getContributor: "getContributor",
  getEmployee: "getEmployee",
  getCampaign: "getCampaign",
};

const CHECK_ID = "e641f54f-a4b8-4f00-206e-08dc5f921fb1";
const PAYROLL_REDUCTION_ID = "9228bfa4-8039-4da6-206d-08dc5f921fb1";
const CREDIT_CARD_ID = "44768491-ef20-44aa-206f-08dc5f921fb1";
const GIFT_INVESTMENT_OPTION_OTHER_ID = "809524cd-af57-4465-2079-08dc5f921fb1";
const AGENCY_OTHER_OPTION_ID = "ac8084b8-c03d-ef11-9f76-a080695b1f39";
const UNDESIGNATED_OPTION_ID = "4cd6ab18-ea45-ef11-8eed-00155d112802";

const privacyOptions: Array<Options> = [
  {
    value: "",
    label: "",
  },
  {
    value: "1",
    label: "Yes",
  },
  {
    value: "2",
    label: "No",
  },
];
const privacyUnanonymousOptions: Array<Options> = [
  {
    value: "1",
    label:
      "I want to be included in ExxonMobil drawings and events (Names could be published via company/Capital Area United Way media)",
  },
  {
    value: "2",
    label:
      "I want to be excluded from all drawings and events (Name will not appear via company/Capital Area United Way media",
  },
];

const TAX_TEXT = "Responsibility for editorial content is solely that of Capital Area United Way. No goods or services will be provided for this contribution. CAUW is a 501(c)(3) tax deductible organization. Tax ID# 72-0447100.";
const DATA_PRIVACY_TEXT = "At Capital Area United Way, we are committed to safeguarding your personal information. We do not share or sell your data to third parties. Your information is exclusively used to facilitate your donations and enhance our services.";

const TAX_TEXT_STYLE = {
  fontSize: "small",
  paddingRight: "40%",
};

const TAX_TEXT_CONFIRMATION_STYLE = {
  fontSize: "small",
};

const TAX_TEXT_STYLE_MOBILE = {
  display: "none"
};

export {
  privacyOptions,
  privacyUnanonymousOptions,
  CHECK_ID,
  PAYROLL_REDUCTION_ID,
  GIFT_INVESTMENT_OPTION_OTHER_ID,
  UNDESIGNATED_OPTION_ID,
  AGENCY_OTHER_OPTION_ID,
  TAX_TEXT,
  TAX_TEXT_CONFIRMATION_STYLE,
  TAX_TEXT_STYLE,
  TAX_TEXT_STYLE_MOBILE,
  DATA_PRIVACY_TEXT,
  CREDIT_CARD_ID
};
